export default __webpack_public_path__ + "static/Khatumal-2fb5b4707f20766c9065a5fb8909d61b.jpg";